import { useTranslation } from 'react-i18next'

import { ButtonWithSpinner, refundMethods } from '@reveni-io/reveni-ui'

const CompleteProcessButton = ({
  refundType,
  completingReturn,
  creatingBankAccount,
  onComplete,
  completingReturnMessage,
}) => {
  const { t } = useTranslation()

  const isDisabled = () => completingReturn

  const isLoading = refundType => {
    if (refundType === refundMethods.bankTransfer) {
      return completingReturn || creatingBankAccount
    }

    return completingReturn
  }

  return (
    <ButtonWithSpinner
      fullWidth
      onClick={() => onComplete(refundType)}
      loadingLabel={t(completingReturnMessage || 'Procesando')}
      disabled={isDisabled(refundType)}
      defaultLabel={t('Enviar solicitud')}
      loading={isLoading(refundType)}
    />
  )
}

export default CompleteProcessButton
